import { jwtDecode } from 'jwt-decode'

// 定义类型接口（根据实际token结构调整）
interface RefreshTokenPayload {
  sub: { userId: string } | string // sub可能是对象或字符串
}

/**
 * 解码refreshToken获取userId
 * @param refreshToken - 待解码的refresh token
 * @returns userId或null
 */
export function getUserIdFromRefreshToken(
  refreshToken: string,
): string | undefined {
  try {
    // 解码payload
    const payload = jwtDecode(refreshToken) as RefreshTokenPayload

    // 处理sub字段（根据实际结构调整）
    if (typeof payload.sub === 'object' && 'userId' in payload.sub) {
      return payload.sub.userId
    } else if (typeof payload.sub === 'string') {
      // 如果sub是JSON字符串格式
      try {
        const subObj = JSON.parse(payload.sub)
        return subObj.userId
      } catch {
        // 如果sub是直接的userId字符串
        return payload.sub
      }
    }
    return undefined
  } catch (error: any) {
    throw new Error('解码refreshToken失败' + error?.message)
  }
}
